import type {
  MessageInlineJumpVo,
  MessageJumpVo,
  UserMessageVo,
} from '@core/types/auto/forum';

export type MessageToken =
  | { type: 'text'; text: string }
  | { type: 'link'; text: string; jump: MessageJumpVo };

export function isNewFormatMessage(item: UserMessageVo): boolean {
  return item.version === 2;
}

export function parseTemplate(
  tpl: string | undefined,
  params: Record<string, string> | undefined,
  inlineJumps: MessageInlineJumpVo[] | undefined,
): MessageToken[] {
  if (!tpl) return [];

  const jumpMap = new Map<string, MessageJumpVo>();
  (inlineJumps ?? []).forEach((inlineJump) => {
    if (inlineJump.paramKey && inlineJump.jump) {
      jumpMap.set(inlineJump.paramKey, inlineJump.jump);
    }
  });

  const tokens: MessageToken[] = [];
  const parts = tpl.split(/(\{\w+\})/);
  for (const part of parts) {
    if (!part) continue;
    const matched = part.match(/^\{(\w+)\}$/);
    if (matched) {
      const key = matched[1];
      const text = String(params?.[key] ?? '');
      const jump = jumpMap.get(key);
      tokens.push(jump ? { type: 'link', text, jump } : { type: 'text', text });
    } else {
      tokens.push({ type: 'text', text: part });
    }
  }
  return tokens;
}

export function renderTemplate(
  tpl: string | undefined,
  params: Record<string, string> | undefined,
): string {
  if (!tpl) return '';
  return tpl.replace(/\{(\w+)\}/g, (_, key) => String(params?.[key] ?? ''));
}

export const MessageType = {
  USER_REPLY: 2,
  SOLUTION_AUDIT_PASS: 4,
  SOLUTION_AUDIT_REJECT: 5,
  SOLUTION_FEATURED: 6,
  SOLUTION_AUDIT_PASS_AND_FEATURED: 7,
  COMMENT_AUDIT_REJECT: 13,
  AWARD_VERIFYING: 15,
  AWARD_APPROVED: 16,
  AWARD_REJECTED: 17,
} as const;
